import { render, staticRenderFns } from "./PortfolioDetailsPage.vue?vue&type=template&id=353a5947&"
import script from "./PortfolioDetailsPage.vue?vue&type=script&lang=js&"
export * from "./PortfolioDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports